import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const UsersPage = lazy(() => import('./pages/UsersPage'));

export const ROUTES = [
    {
        path: '/users',
        element: (
            <Suspense fallback={<Spinner block />}>
                <UsersPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
